import { CommonModule } from '@angular/common';
import { Directive, inject, Input, signal } from '@angular/core';
import { DictionaryService } from '../../services/dictionary.service';

@Directive({
  selector: '[base]',
})
export abstract class TabComponent {
  @Input() name: string = '';
  dictionaryService = inject(DictionaryService);

  // Shared state management
  loading = signal<boolean>(true);
  initialized = signal<boolean>(false);
  error: string | null = null;

  // protected abstract fetchData(): Promise<void>;

  abstract main(): Promise<void>;
}
